module.exports = __webpack_public_path__ + "static/media/banner-mobile.e363a927.png";